import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavbarModule } from '../navbar/navbar.module';
import { FooterModule } from '../footer/footer.module';
import { SidebarModule } from '../sidebar/sidebar.module';
import { RouterModule } from '@angular/router';
import { CoreModule } from '../core/core.module';
import { DefaultMainLayoutComponent } from './components/default-main-layout/default-main-layout.component';
import { MainLayout1Component } from './components/main-layout1/main-layout1.component';
import { MainLayout2Component } from './components/main-layout2/main-layout2.component';
import { Common2Module, AppModule } from 'projects/common/src/app/app.module';
import { DefaultLayoutComponent } from './components/default-layout/default-layout.component';
import { DefaultHeaderLayoutComponent } from './components/default-header-layout/default-header-layout.component';
import { InitNavigationService } from '../app/services/init-navigation.service';
import { LoadLayoutComponent } from './components/load-layout/load-layout.component';

@NgModule({
  declarations: [
    DefaultMainLayoutComponent,
    MainLayout1Component,
    MainLayout2Component,
    DefaultLayoutComponent,
    DefaultHeaderLayoutComponent,
    LoadLayoutComponent
  ],
  providers: [
    InitNavigationService
  ],
  imports: [
    CommonModule,
    RouterModule,
    NavbarModule,
    SidebarModule,
    FooterModule,
    CoreModule,
    AppModule,
    Common2Module.forRoot(),
  ],
  exports: [
    DefaultMainLayoutComponent,
    DefaultLayoutComponent,
    LoadLayoutComponent
  ],
})
export class LayoutModule { }
